<template>
  <div>
<h2>学生名称：{{studentsname}}</h2>
<h2>学生地址：{{studentsaddress}}</h2>
<button @click="showname">点击</button>
  </div>
</template>

<script>
export default {
name:"students",
beforeDestroy(){
console.log("学生组件被销毁了")
},
data(){
    return{ 
    studentsname:"小天呀",
    studentsaddress:"河南"
    }

},
  methods:{
      showname(){
        alert(this.studentsname)
      }  
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/study/study3/students.vue